// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPortsInUse = getPortsInUse;
const tslib_1 = require("tslib");
const teamsfx_api_1 = require("@microsoft/teamsfx-api");
const detect_port_1 = tslib_1.__importDefault(require("detect-port"));
const error_1 = require("../../error");
const telemetry_1 = require("../../common/telemetry");
async function detectPortListening(port, logger) {
    try {
        (0, telemetry_1.sendTelemetryEvent)(telemetry_1.Component.core, telemetry_1.TelemetryEvent.DetectPortStart, { port: port.toString() });
        const race = Promise.race([
            (0, detect_port_1.default)(port),
            // in case `detectPort` hangs, set 10 seconds timeout
            new Promise((resolve) => setTimeout(() => resolve(port), 10 * 1000)),
        ]);
        const portChosen = await race;
        (0, telemetry_1.sendTelemetryEvent)(telemetry_1.Component.core, telemetry_1.TelemetryEvent.DetectPort, {
            portChosen: portChosen.toString(),
            port: port.toString(),
        });
        return portChosen !== port;
    }
    catch (error) {
        // ignore any error to not block debugging
        (0, telemetry_1.sendTelemetryErrorEvent)(telemetry_1.Component.core, telemetry_1.TelemetryEvent.DetectPort, new teamsfx_api_1.UserError({ error, source: error_1.CoreSource, name: "DetectPortError" }));
        logger?.warning(`Failed to detect port. ${error?.message} `);
        return false;
    }
}
async function getPortsInUse(ports, logger) {
    const portsInUse = [];
    for (const port of ports) {
        if (await detectPortListening(port, logger)) {
            portsInUse.push(port);
        }
    }
    return portsInUse;
}
//# sourceMappingURL=portChecker.js.map